import {
  Paper,
  Skeleton,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { CommonService } from "../../Service/CommonService";
import HistoryIcon from '@mui/icons-material/History';
import { useHistory } from "react-router";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Constant from "../../Constant";
import DataGridLoader from "../Common/DataGridLoader";

interface ChildProps {
  historyData: any[];
  isMarketValueHistory?: boolean;
  isLoading?: boolean;
  requestId?: any;
  serviceName?: any;
}

export const HistoryStepper: React.FC<ChildProps> = ({ historyData, isMarketValueHistory, isLoading, requestId, serviceName }) => {

  const history = useHistory();

  const handleViewHistoryClick = (historyId: any) => {

    const path = CommonService.isAdmin()
      ? `/master/view-edit-sell-request-history/${requestId}/${historyId}`
      : `/user/view-edit-sell-request-history/${requestId}/${historyId}`;

    history.push(path);
  };

  return (
    <Paper elevation={3} style={{ padding: "16px", margin: "16px" }} className={`${isMarketValueHistory && historyData.length === 0 ? "d-flex align-items-center justify-content-center h-100 flex-column":"" }`}>
    {isLoading ? (
      <div className="d-flex align-items-center justify-content-center" style={{ height: "300px" }}>
        <DataGridLoader />
      </div>
    ) : isMarketValueHistory && historyData.length === 0 ? (
    <>
    <HistoryIcon sx={{height:"6em",width:"6em",color:"#737376"}}/>
    <Typography variant="h6" color="textSecondary">
      No market value history available
    </Typography>
    </>
  ) : historyData.length === 0 ? (
    <Skeleton animation="wave" variant="rounded" style={{ height: "100%" }} />
  ) : (
    <>
      {historyData.map((historyGroup: any, groupIndex: any) => (
        <div
          key={groupIndex}
          className={`history-item d-flex align-items-start ${
            groupIndex === historyData.length - 1 ? "last-child" : ""
          }`}
        >
          <Typography style={{ marginRight: "16px", minWidth: 100, marginTop: 4 }}>
            {new Date(historyGroup.date).toLocaleDateString("en-US", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
          </Typography>
          <Stepper orientation="vertical">
            <Step active>
              <StepLabel />
              <StepContent>
                {historyGroup.histories.map((history: any, index: any) => (
                  <div className="history-content" key={index}>
                    <Typography variant="subtitle1">
                      <div className="d-flex flex-column flex-sm-row gap-2 gap-sm-4">
                        <b className="text-nowrap">
                          {CommonService.formatRecentActivityTime(history.createdDate)}{" "}
                        </b>
                        <span>
                          {!isMarketValueHistory && (
                            <>
                              {history.firstName} {history.lastName} - {CommonService.formatRoleName(history.roleName)} |{" "}
                            </>
                          )}
                          {isMarketValueHistory ? (
                            <span>
                              Current Value Updated <b>${history?.newMarketValuePerBarrel}</b> from{" "}
                              <b>${history?.previousMarketValuePerBarrel || 0}</b> by{" "}
                              <b>{history?.changedBy}</b>
                            </span>
                          ) : (
                            <>
                            {history.description  || "No description provided"}

                            {(history.description === 'Updated service request' && serviceName == Constant.CustomerService.SELL_REQUEST) && (
                            <span onClick={() => handleViewHistoryClick(history.id)} className="ms-2 view-edit-text" style={{ cursor: 'pointer' }}>
                              View Edits <VisibilityOutlinedIcon sx={{height:"20px"}}/>
                            </span>)}
                            </>
                          )}
                        </span>
                      </div>
                    </Typography>
                  </div>
                ))}
              </StepContent>
            </Step>
          </Stepper>
        </div>
      ))}
    </>
  )}
</Paper>

  );
};
